import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M70 135c35.899 0 65-29.101 65-65 0-35.898-29.101-65-65-65C34.102 5 5 34.102 5 70c0 35.899 29.102 65 65 65Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m55 45 40 25-40 25V45Z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }